<!-- 代码已包含 CSS：使用 TailwindCSS , 安装 TailwindCSS 后方可看到布局样式效果 -->

<template>
    <div class="min-h-screen bg-gray-50">
      <!-- 头部导航 -->
          <!-- 筛选区域 -->
          <div class="bg-white rounded-lg shadow-sm p-6 mb-6">
        <div class="flex justify-between items-center">
          <div class="flex items-center gap-4">
            <!-- 供应商下拉选择 -->
            <div class="relative"  v-if="isuse == 1">
              <button @click="toggleSupplierDropdown" class="flex items-center gap-2 px-4 py-2 border border-gray-200 rounded-button bg-white text-gray-700 hover:bg-gray-50">
                <i class="fas fa-building"></i>
                <span class="whitespace-nowrap">{{ selectedSupplier.name || '选择供应商' }}</span>
                <i class="fas fa-chevron-down text-gray-400"></i>
              </button>
              <div v-if="showSupplierDropdown" class="absolute z-10 w-56 mt-2 bg-white border border-gray-200 rounded-lg shadow-lg">
                <div class="py-2">
                  <div v-for="item in supply" :key="item.supply_id" @click="selectSupplier(item)" class="px-4 py-2 hover:bg-gray-50 cursor-pointer">
                     {{item.name}}
                  </div>
                </div>
              </div>
            </div>

            <div class="relative" v-if="form.supply_id || form.supply_id == 0">
              <button @click="toggleSupplierDropdownd" class="flex items-center gap-2 px-4 py-2 border border-gray-200 rounded-button bg-white text-gray-700 hover:bg-gray-50">
                <i class="fas fa-building"></i>
                <span class="whitespace-nowrap">{{ selectedSupplierd.nickName || '选择司机' }}</span>
                <i class="fas fa-chevron-down text-gray-400"></i>
              </button>
              <div v-if="showSupplierDropdownd" class="absolute z-10 w-56 mt-2 bg-white border border-gray-200 rounded-lg shadow-lg">
                <div class="py-2">
                  <div v-for="item in driver" :key="item.user_id" @click="selectSupplierd(item)" class="px-4 py-2 hover:bg-gray-50 cursor-pointer">
                     {{item.nickName}}
                  </div>
                </div>
              </div>
            </div>
            
            <!-- 日期范围选择 -->
            <div class="flex items-center gap-2">
              <input type="date" v-model="form.startDate" class="px-4 py-2 border border-gray-200 rounded-button bg-white text-gray-700">
              <span class="text-gray-500">至</span>
              <input type="date" v-model="form.endDate" class="px-4 py-2 border border-gray-200 rounded-button bg-white text-gray-700">
            </div>
          </div>

        
        <button  @click="search" class="px-6 py-2 bg-blue-600 text-white rounded-button hover:bg-blue-700 flex items-center gap-2">
             
                <span class="whitespace-nowrap">查询</span>
          </button>
          

        </div>
      </div>
  
      <!-- 主要内容区 -->
      <div class=" px-4 pb-6">
        <!-- 数据概览卡片 -->
        <div class="grid grid-cols-2 gap-4 mb-6">
          <div class="bg-white rounded-lg p-4 shadow-sm">
            <div class="text-3xl font-semibold text-blue-600">{{ obj.totalCount }}</div>
            <div class="text-sm text-gray-500 mt-1">配送总单数</div>
            <div class="mt-3">
              <div class="w-full bg-gray-200 rounded-full h-2">
                <div class="bg-blue-600 h-2 rounded-full" style="width: 75%"></div>
              </div>
            </div>
          </div>
          <div class="bg-white rounded-lg p-4 shadow-sm">
            <div class="text-3xl font-semibold text-green-600">{{ obj.completedCount }}</div>
            <div class="text-sm text-gray-500 mt-1">已完成配送</div>
            <div class="mt-3 text-sm text-green-600">
              完成率 {{ obj.completionRate }}%
              <i class="fas fa-arrow-up ml-1"></i>
            </div>
          </div>
        </div>
  
        <!-- 配送进度图表 -->
        <div class="bg-white rounded-lg p-4 mb-6 shadow-sm">
          <div ref="chart" class="w-full h-64"></div>
        </div>
  
        <!-- 搜索栏 -->
        <!-- <div class="flex items-center gap-4 mb-6">
          <div class="flex-1 relative">
            <input
              type="text"
              placeholder="搜索订单编号/目的地"
              class="w-full h-10 pl-10 pr-4 rounded-lg border-none bg-white shadow-sm"
            />
            <i class="fas fa-search absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"></i>
          </div>
          <button class="!rounded-button whitespace-nowrap h-10 px-4 bg-blue-600 text-white hover:bg-blue-700">
            <i class="fas fa-filter mr-2"></i>
            筛选
          </button>
        </div> -->
  
        <!-- 配送列表 -->
        <div class="space-y-4">
          <div v-for="item in deliveryList" :key="item.id" class="bg-white rounded-lg p-4 shadow-sm">
            <div class="flex items-center justify-between mb-3">
              <div class="font-medium">订单 #{{item.id}}</div>
              <div :class="getStatusClass(item.status)">{{item.statusText}}</div>
            </div>
            <div class="text-sm text-gray-500 space-y-2">
              <div class="flex items-start">
                <i class="fas fa-map-marker-alt w-5 mt-1"></i>
                <div class="flex-1">{{item.address}}</div>
              </div>
              <div class="flex items-start">
                <i class="fas fa-clock w-5 mt-1"></i>
                <div class="flex-1">门店：{{item.stores}}</div>
              </div>
              <!-- <div class="flex items-start">
                <i class="fas fa-box w-5 mt-1"></i>
                <div class="flex-1">{{item.goods}}</div>
              </div> -->
            </div>
          </div>
          <div class="pagination">
            <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            background :current-page="curPage"
            :page-sizes="[20, 100,500, 1000]"
            layout="total,sizes, prev, pager, next, jumper"
            :total="totalDataNumber"></el-pagination>
        </div>
  
        </div>

      </div>
    </div>
  </template>
  
  <script>
  import * as echarts from 'echarts';
  import StatisticsApi from '@/api/statistics.js';
  import Warehouse_managementApi from '@/api/warehouse_management.js';

  export default {
    data() {
      return {
        selectedSupplier: {'name':""},
        showSupplierDropdown: false,
        selectedSupplierd: {'nickName':""},
        showSupplierDropdownd: false,
        startDate: '',
        endDate: '',
        supply:[],
        driver:[],
        form:{
            startDate: '',
            endDate: '',
            driver_id:"",
        },
        isuse:0,
        deliveryList: [
          {
            id: 'DD20230615001',
            status: 'completed',
            statusText: '已完成',
            address: '上海市浦东新区张江高科技园区科苑路 88 号',
            expectedTime: '2023-06-15 14:30',
            goods: '生鲜食材 x 12、饮品 x 24'
          },
          {
            id: 'DD20230615002',
            status: 'inProgress',
            statusText: '配送中',
            address: '上海市徐汇区虹桥路 1 号港汇广场',
            expectedTime: '2023-06-15 15:00',
            goods: '蔬菜 x 30、水果 x 15'
          },
          {
            id: 'DD20230615003',
            status: 'pending',
            statusText: '待配送',
            address: '上海市长宁区天山路 789 号',
            expectedTime: '2023-06-15 16:30',
            goods: '肉类 x 8、海鲜 x 10'
          }
        ],
        obj:{},
                  /*一页多少条*/
                  pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        form:{},
        productSearch:"",
      };
    },
    mounted() {
             /*获取数据*/
      var self = this;
      self.getInas({},function(res){
        self.isuse = res
      })
      self.getSupplys()

      self.search()
    },
    methods: {
        search(){
            this.getTodayDeliveryStats();
            this.getDeliveryTrendChart();
            this.getDeliveryList();
        },
     /*选择第几页*/
     handleCurrentChange(val) {
            this.curPage = val
            this.getDeliveryList()
            },
            /*每页多少条*/
            handleSizeChange(val) {
            this.curPage = 1
            this.pageSize = val
            this.getDeliveryList()
        },
        /*获取数据*/
        getTodayDeliveryStats() {
            let self = this;
            StatisticsApi.getTodayDeliveryStats(self.form, true)
            .then(res => {
                    self.obj = res.data;
            })
            .catch(error => {});
      },
         /*获取数据*/
         getDeliveryTrendChart() {
            let self = this;
            const chart = echarts.init(self.$refs.chart);
            StatisticsApi.getDeliveryTrendChart(self.form, true)
            .then(res => {
    
                    chart.setOption( res.data);
            })
            .catch(error => {});
      },
            /*获取数据*/
            getDeliveryList() {
            let self = this;
            let Params = self.form
            Params.page = self.curPage
            Params.list_rows = self.pageSize
            StatisticsApi.getDeliveryList(Params, true)
            .then(res => {
                    self.deliveryList = res.data.list;
                    self.totalDataNumber = res.data.total
            })
            .catch(error => {});
      },
      initChart() {
        const chart = echarts.init(this.$refs.chart);
        const option = {
          animation: false,
          tooltip: {
            trigger: 'axis'
          },
          legend: {
            data: ['配送总量', '完成量']
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: ['周一', '周二', '周三', '周四', '周五', '周六', '周日']
          },
          yAxis: {
            type: 'value'
          },
          series: [
            {
              name: '配送总量',
              type: 'line',
              data: [120, 132, 101, 134, 90, 230, 210],
              smooth: true,
              lineStyle: {
                width: 3
              }
            },
            {
              name: '完成量',
              type: 'line',
              data: [110, 122, 91, 124, 85, 220, 200],
              smooth: true,
              lineStyle: {
                width: 3
              }
            }
          ]
        };
        chart.setOption(option);
      },
      getStatusClass(status) {
        const classes = {
          completed: 'text-green-600',
          inProgress: 'text-blue-600',
          pending: 'text-orange-600'
        };
        return classes[status] || '';
      },
      getDriver(){
            let self = this;
    
    
            Warehouse_managementApi.getDriver({
              supply_id:self.form.supply_id
            }, true)
                .then(data => {
              
                self.driver = data.data
           
                })
                .catch(error => {
                });
        },
      getSupplys(){
            let self = this;
    
    
            Warehouse_managementApi.getSupply({}, true)
                .then(data => {
              
                self.supply = data.data.supply
           
                })
                .catch(error => {
                });
        },
        toggleSupplierDropdown() {
        this.showSupplierDropdown = !this.showSupplierDropdown;
        this.form.driver_id = "";
      },
      selectSupplier(supplier) {
        this.selectedSupplier = supplier;
        this.showSupplierDropdown = false;
        this.form.supply_id = supplier.supply_id
        this.form.driver_id = "";
        this.getDriver();
      },
 


      toggleSupplierDropdownd() {
        this.showSupplierDropdownd = !this.showSupplierDropdown;
      },
      selectSupplierd(supplier) {
        this.selectedSupplierd = supplier;
        this.showSupplierDropdownd = false;
        this.form.driver_id = supplier.user_id
      },

 
   
    }
  };
  </script>
  
  <style scoped>
  .delivery-status {
    padding: 2px 8px;
    border-radius: 12px;
    font-size: 12px;
  }
  </style>
  
  


// WEBPACK FOOTER //
// src/views/statistics/driver/indexx.vue